import angular from "angular";

import { moduleName as recordsModuleName } from "../../../records";
import { vsModuleName as shareMachineModuleName } from "../../shared";
import { machineConfigurationConfig } from "./machineConfiguration";
import { machineDetailTabComponentConfigure } from "./configureMachineDetailTabs";
import { changesConfig } from "./changes";
import { machineConfig } from "./machine";
import { machineGameConfig } from "./machineGameConfiguration";

import { vsModuleName as lookupConfigModuleName } from "./lookup/module";
import { machineEpromConfigurationConfig } from "./machineEpromConfigurations";
import { machineTypeIdConfig } from "./machineTypeId";
import {
  MachineConfigurationCellClassServiceProvider,
  vsServiceName as machineConfigurationCellClassName,
} from "./machineConfigurationCellClassService";

export const vsModuleName = "SlotTrak.Machines.Config";

angular
  .module(vsModuleName, [
    recordsModuleName,
    shareMachineModuleName,
    lookupConfigModuleName,
  ])
  .config(machineConfigurationConfig)
  .config(machineDetailTabComponentConfigure)
  .config(changesConfig)
  .config(machineConfig)
  .config(machineGameConfig)
  .config(machineEpromConfigurationConfig)
  .config(machineTypeIdConfig)
  .provider(
    machineConfigurationCellClassName,
    MachineConfigurationCellClassServiceProvider
  );
